import { Component, ComponentRef, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalComponent, ModalResult } from '@michelin/theme';
import { Subscription } from 'rxjs';
import { HspModalContainerDirective } from './hsp-modal-container.directive';
import { HspModal } from './hsp-modal.interface';
import { HspModalData, HspModalEventsService } from './hsp-modal.service';

const CURRENT_MODAL = 'current-modal';

@Component({
    selector: 'hsp-modal-wrapper',
    templateUrl: './hsp-modal-wrapper.component.html',
})
export class HspModalWrapperComponent implements OnInit, OnDestroy {
    @ViewChild('generalModal')
    public generalModal: ModalComponent;

    @ViewChild(HspModalContainerDirective, {static: false})
    public hspModalHost: HspModalContainerDirective;

    private openSub: Subscription;
    private closeSub: Subscription;
    private modalComponent: ComponentRef<HspModal>;

    public constructor(
        private readonly viewContainerRef: ViewContainerRef ,
        private readonly modalEventsService: HspModalEventsService) {}

    public ngOnInit(): void {
        this.openSub = this.modalEventsService.modalOpen.subscribe((data: HspModalData) => this.openModal(data));
        this.closeSub = this.modalEventsService.modalClose.subscribe(() => this.closeModal());
    }

    public ngOnDestroy(): void {
        this.openSub.unsubscribe();
        this.closeSub.unsubscribe();
    }

    public onModalClosed(result: ModalResult): void {
        this.modalEventsService.notifyModalClose({status: (result && result.result as boolean)});
    }

    private closeModal(): void {
        this.generalModal.dialog.closeAll();
    }

    private openModal<T>(modal: HspModalData): void {
        const viewContainerRef = this.hspModalHost.viewContainerRef;
        viewContainerRef.clear();

        this.modalComponent = viewContainerRef.createComponent<HspModal>(modal.component);
        this.modalComponent.instance.inputData = modal.input as T;

        this.modalComponent.instance.onModalComponentReady().subscribe(() => {
            this.generalModal.open({
                id: CURRENT_MODAL,
                width: modal.width,
                title: modal.title,
                content: this.modalComponent.instance.contentTemplate,
                confirm: modal.confirm,
                cancel: modal.cancel
            });
        });
    }
}
